export interface SurfaceThemeRefreshableRenderer {
  refresh(target?: { type: 'all' }): void;
}

export function refreshSurfaceForThemeChange(
  renderer: SurfaceThemeRefreshableRenderer | undefined,
  requestUpdate: () => void
) {
  requestUpdate();
  renderer?.refresh({ type: 'all' });
}
